import Validators from "../Validators";

export function useRules(...rules: string[])
{
    return (value: unknown) => rules.map((rule) => Validators[rule]).flatMap((f) => (f(value), f.errors)).filter((v) => v !== null).map(({message}) => message as string);
}